import { formatRecommendationCurrency, formatRecommendationPct } from '@/api/recommendationFormat';

type RecommendationThresholdsBannerProps = {
  thresholds: Record<string, number | null | undefined>;
  eligibleCount?: number;
};

export function RecommendationThresholdsBanner({
  thresholds,
  eligibleCount,
}: RecommendationThresholdsBannerProps) {
  return (
    <div className="rounded-xl border border-border bg-page px-4 py-3 text-sm text-foreground-muted">
      <p>
        Only <strong>ENABLED</strong> keywords with at least{' '}
        <strong>{formatRecommendationCurrency(Number(thresholds.minCost ?? 0))}</strong> spend and{' '}
        <strong>{thresholds.minClicks}</strong> clicks are scored.
        {thresholds.targetAcos != null ? (
          <>
            {' '}
            Target ACOS:{' '}
            <strong>{formatRecommendationPct(Number(thresholds.targetAcos))}</strong>.
          </>
        ) : null}
      </p>
      <p className="mt-1 text-xs text-foreground-subtle">
        Bid changes use +{thresholds.bidIncreasePct}% / −{thresholds.bidDecreasePct}%. Pause when
        spend ≥ {formatRecommendationCurrency(Number(thresholds.wastefulCost ?? 0))} with zero
        orders.
        {eligibleCount != null ? ` ${eligibleCount} eligible keywords.` : ''}
      </p>
    </div>
  );
}
